import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Render a designer-built component as the feed's empty state instead of
// `empty-state-text`. Holds a destination DynamicComponent id, so the key is
// registered in BOTH dependency walkers (helpers/component-reference-keys.js
// and Models/Studio/DcDependencyWalker.php) — without that the compiled
// closure omits the component and staging renders InvalidElement.
//
// Candidates come from the store's `authoredComponentCandidates`, the same
// isComponentRowVisible filter the Elements palette's Components folder uses,
// so only components the author created are offered.
export default class EmptyStateComponentId extends BaseOption {
  // Compile is the identity: a cached value unlike the raw one is stale (DynamicOption ignores it).
  static compiledIsRaw = true;

  static userInterfaceComponent = {
    label: "Component",
    component: inspectorTools.REFERENCED_COMPONENT_PICKER,
    descriptionMessage: "Shown instead of the message when the feed has nothing to show.",
    props: {
      candidateSource: "authored",
      // Sits in a labelled row inside the "Empty State" section; the picker's
      // inline leading pencil would misalign it against the text row above.
      showOpenButton: false,
    },
  };

  static defaultValue = 0;
}
